/**
 * Defines the existing user types.
 */
export const userTypes = {
  viewer: 'Viewer',
  creator: 'Creator'
};

/**
 * Returns the user types, including the type 'Admin' if the specified user is an admin.
 */
export const getUserTypesWithAdmin = user => ({
  ...userTypes,
  ...(user.isAdmin ? { admin: 'Admin' } : {})
});

export const KgPermissions = {
  Read: 'Read',
  Write: 'Write',
  KgMetadataWrite: 'KgMetadataWrite',
  KgDelete: 'KgDelete',
  KgVklRead: 'KgVklRead',
  KgSync: 'KgSync',
  DatabaseSchemaImport: 'DatabaseSchemaImport',
  DatabaseSchemaRead: 'DatabaseSchemaRead',
  DatabaseQuery: 'DatabaseQuery',
  DatabaseConnectionRead: 'DatabaseConnectionRead',
  DatabaseConnectionWrite: 'DatabaseConnectionWrite',
  UpdateAccessControl: 'UpdateAccessControl'
};
